import React, {Component} from 'react';
import {connect} from 'react-redux';
import PromoVideoFolder from "./PromoVideoFolder";
import {Button} from "reactstrap";

class PromoVideoFolderList extends Component {

    render() {
        const {folders, parentFolderId} = this.props;
        const renderList = folders
            ? folders.map(folder =>
                <PromoVideoFolder
                    folder={folder}
                    addFolder={this.props.addFolder}
                    renameFolder={this.props.renameFolder}
                    deleteFolder={this.props.deleteFolder}
                    addUrl={this.props.addUrl}
                    changeUrlValue={this.props.changeUrlValue}
                    deleteUrl={this.props.deleteUrl}
                    onOpenFoldersChange={this.props.onOpenFoldersChange}
                    openFolderIds={this.props.openFolderIds}
                />)
            : null;

        return (
            <div>
                {renderList}
                <Button
                    onClick={() => this.props.addFolder(parentFolderId)}
                    size="sm"
                    round="true"
                    icon="true"
                    color="inverse"
                >
                    <i className="fa fa-plus"/>
                </Button>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    lang: state.languageReducer.lang,
});

export default connect(mapStateToProps)(PromoVideoFolderList)



// WEBPACK FOOTER //
// ./src/components/PromoVideo/PromoVideoFolderList.js